import React from 'react';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import {
  leagueTablesImageCaption,
  leagueTablesNoAccessDescription,
  leagueTablesNoAccessFeatures,
  PAGE_TITLE,
} from '@/creditflowresearch/ui/components/league/LeagueTablePage/constants';
import image from '@/creditflowresearch/ui/assets/noAccess/leagueTablesNoAccess.webp';

export const LeagueTablesNoAccessComponent = (
  <NoAccessOverlay
    title={ PAGE_TITLE }
    features={ leagueTablesNoAccessFeatures }
    description={ leagueTablesNoAccessDescription }
    imageCaption={ leagueTablesImageCaption }
    image={ image.src }
    isDoubleImage
  />
);
